import { useCallback, useEffect, useState } from 'react';
import { InputBackOffice } from '../../../components/common/InputBackoffice';
import { P1, P2 } from '../../../styles/FontStyles';
import { ArrowPolygon, Button, Select } from '../../../styles/GlobalComponents';

import BottomDrawer from '../../../components/common/BottomDrawer';
import {
  FlexCenter,
  Label,
  SInput,
  SInputContainer
} from '../../../styles/stylesStyled';
import check from '../../../assets/icons/check.svg';
import search from '../../../assets/icons/search.svg';

import countries from '../../../lib/countries';
import axios from 'axios';
import { useAppSelector } from '../../../app/hooks';
import Spinner from '../../../components/common/Spinner';
import { PurchaseSteps, SubsctriptionTypes } from '../Maeketplace.types';

import {
  setOrderId,
  setPurchaseCardStep,
  verifyPayTravelutionBundle,
  verifyPayTravelutionGoldenCard,
  verifyPayEventTickets,
  verifyPayTravelutionLicence,
  verifyPayTravelutionMembership,
  verifyPayTravelutionSubscription,
  verifySuperSales,
  verifyAccessPacks
} from '../Marketplace.actions';
import { useDispatch } from 'react-redux';
import { ErrorToast } from '../../../components';

const PaymentPage = ({ selectedPackage }: { selectedPackage: any }) => {
  const [loading, setLoading] = useState(false);
  const [name, setName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [address, setAddress] = useState('');
  const [city, setCity] = useState('');
  const [postal, setPostal] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [country, setCountry] = useState('');
  const [userCountry] = useState('');
  const [countryCode, setCountryCode] = useState('');
  const [countryList, setCountryList] = useState(countries);
  const [countryImage, setCountryImage] = useState('');
  const dispatch = useDispatch();

  const [isVisible, setIsVisible] = useState(false);

  const { orderId } = useAppSelector((state) => state.marketplace);

  const checkCountry = (country: any) => {
    setCountryList(
      countryList.map((item) =>
        item.name === country.name
          ? {
              ...item,
              checked: true
            }
          : {
              ...item,
              checked: false
            }
      )
    );
  };

  useEffect(() => {
    if (selectedPackage?.orderId) {
      dispatch(setOrderId({ orderId: selectedPackage?.orderId }));
    }
  }, [selectedPackage]);

  const onClose = useCallback(() => {
    setIsVisible(false);
  }, []);

  const getMembershipSession = async () => {
    try {
      const { data } = await axios.get(
        `/products/travelution-memberships/${orderId}/tmt/init`
      );
      return data.data;
    } catch (error: any) {
      console.log(error);
    }
  };

  const getAccessPacksSession = async () => {
    try {
      const { data } = await axios.get(
        `/products/travelution-access-packs/${orderId}/tmt/init`
      );
      return data.data;
    } catch (error: any) {
      console.log(error);
    }
  };

  const getTravelutionSubscriptionSession = async () => {
    try {
      const { data } = await axios.get(
        `/products/travelution-subscriptions/${orderId}/tmt/init`
      );
      return data.data;
    } catch (error: any) {
      console.log(error);
    }
  };

  const getTravelutionGoldenCardSession = async () => {
    try {
      const { data } = await axios.get(
        `/products/travelution-golden-cards/${orderId}/tmt/init`
      );
      return data.data;
    } catch (error: any) {
      console.log(error);
    }
  };

  const getTravelutionBundleSession = async () => {
    try {
      const { data } = await axios.get(
        `/products/travelution-subscription-bundles/${orderId}/tmt/init`
      );
      return data.data;
    } catch (error: any) {
      console.log(error);
    }
  };

  const getAxiosErrorMessage = (error: unknown) => {
    if (axios.isAxiosError(error)) {
      return (
        error.response?.data?.error ||
        error.response?.data?.message ||
        error.message
      );
    }
    return 'Unexpected error';
  };

  const getEventTicketSession = async () => {
    try {
      const { data } = await axios.get(
        `/products/event-tickets/${orderId}/tmt/init`
      );
      return data.data;
    } catch (error) {
      ErrorToast(getAxiosErrorMessage(error));
    }
  };

  const getSuperSalesSession = async () => {
    try {
      const { data } = await axios.get(
        `/products/travelution-super-sales/${orderId}/tmt/init`
      );
      return data.data;
    } catch (error: any) {
      console.log(error);
    }
  };

  const getTravelutionBackofficeLicenceSession = async () => {
    try {
      const { data } = await axios.get(
        `/products/backoffice-licences/${orderId}/tmt/init`
      );
      return data.data;
    } catch (error: any) {
      console.log(error);
    }
  };

  const handleOpenModal = async () => {
    setLoading(true);

    if (!window.tmtPaymentModalSdk) {
      console.error('TMT Payment Modal SDK not loaded yet');
      return;
    }

    let data;

    if (selectedPackage.type === SubsctriptionTypes.TRAVEL_PACKAGES) {
      data = await getMembershipSession();
    } else if (selectedPackage.type === SubsctriptionTypes.SUBSCRIPTION) {
      data = await getTravelutionSubscriptionSession();
    } else if (selectedPackage.type === SubsctriptionTypes.EVENT_TICKETS) {
      data = await getEventTicketSession();
    } else if (selectedPackage.type === SubsctriptionTypes.GOLDEN_CARD) {
      data = await getTravelutionGoldenCardSession();
    } else if (selectedPackage.type === SubsctriptionTypes.SUBCRIPTION_BUNDLE) {
      data = await getTravelutionBundleSession();
    } else if (selectedPackage.type === SubsctriptionTypes.SUPER_SALES) {
      data = await getSuperSalesSession();
    } else if (selectedPackage.type === SubsctriptionTypes.ACCESS_PACKS) {
      data = await getAccessPacksSession();
    } else {
      data = await getTravelutionBackofficeLicenceSession();
    }

    setLoading(false);

    if (data) {
      const tmtPaymentModal = new window.tmtPaymentModalSdk({
        path: data!.products.path,
        environment: data!.products.environment,
        data: {
          ...data!.products.data,
          payee_name: `${name} ${lastName}`,
          payee_email: email,
          payee_address: address,
          payee_city: city,
          payee_country: countryCode,
          payee_postcode: postal,
          country: countryCode
        },
        callbacks: {
          transaction_result_available: async function (payload: any) {
            await fetch('/tmt/verify', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                transaction_id: payload?.transaction_id || payload?.id
              })
            });

            window.location.href = '/thank-you';
          },

          transaction_failed: function (payload: any) {
            console.warn('Payment failed', payload);
            alert('Payment failed. Please try another card.');
          },

          modal_closed: function () {
            console.log('Modal closed by user.');
          }
        }
      });
      tmtPaymentModal.on('transaction_logged', function (data: any) {
        tmtPaymentModal.closeModal();
        setLoading(false);

        if (selectedPackage.type === SubsctriptionTypes.TRAVEL_PACKAGES) {
          dispatch(verifyPayTravelutionMembership({ orderId }));
        } else if (selectedPackage.type === SubsctriptionTypes.SUBSCRIPTION) {
          dispatch(verifyPayTravelutionSubscription({ orderId }));
        } else if (selectedPackage.type === SubsctriptionTypes.EVENT_TICKETS) {
          dispatch(verifyPayEventTickets({ orderId }));
        } else if (selectedPackage.type === SubsctriptionTypes.GOLDEN_CARD) {
          dispatch(verifyPayTravelutionGoldenCard({ orderId }));
        } else if (
          selectedPackage.type === SubsctriptionTypes.SUBCRIPTION_BUNDLE
        ) {
          dispatch(verifyPayTravelutionBundle({ orderId }));
        } else if (selectedPackage.type === SubsctriptionTypes.SUPER_SALES) {
          dispatch(verifySuperSales({ orderId }));
        } else if (selectedPackage.type === SubsctriptionTypes.ACCESS_PACKS) {
          dispatch(verifyAccessPacks({ orderId }));
        } else {
          dispatch(verifyPayTravelutionLicence({ orderId }));
        }
        dispatch(setPurchaseCardStep({ step: PurchaseSteps.SUCCESS }));
      });

      tmtPaymentModal.on('transaction_failed', function (data: any) {
        // Transaction rejected by the bank.
        setLoading(false);
        dispatch(setPurchaseCardStep({ step: PurchaseSteps.FAILED }));
      });

      tmtPaymentModal.on('transaction_timeout', function (data: any) {
        // Transaction result unknown due to timeout
        setLoading(false);
        dispatch(setPurchaseCardStep({ step: PurchaseSteps.FAILED }));
      });

      tmtPaymentModal.on('token_error', function (data: any) {
        // Token has expired, reload page to generate new authstring.
        setLoading(false);
        dispatch(setPurchaseCardStep({ step: PurchaseSteps.FAILED }));
      });

      tmtPaymentModal.on('transaction_error', function (data: any) {
        // Transaction data is invalid
        setLoading(false);
        dispatch(setPurchaseCardStep({ step: PurchaseSteps.FAILED }));
      });

      tmtPaymentModal.on('modal_closed', function (data: any) {
        setLoading(false);
      });
    }
  };

  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://payment.tmtprotects.com/tmt-payment-modal.3.6.1.js';
    script.async = true;
    document.body.appendChild(script);

    // When the SDK is ready
    window.tmtPaymentModalReady = () => {
      console.log('TMT Payment Modal ready');
    };

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <>
      {loading ? (
        <Spinner />
      ) : (
        <div>
          <P1 bold mb={'20'}>
            Billing Details
          </P1>
          <Label>First name</Label>
          <InputBackOffice
            type={'text'}
            placeholder='Enter your first name'
            name={'name'}
            value={name}
            onChange={setName}
          />
          <Label>Last name</Label>
          <InputBackOffice
            type={'text'}
            placeholder='Enter your last name'
            name={'lastName'}
            value={lastName}
            onChange={setLastName}
          />
          <Label>Email</Label>
          <InputBackOffice
            type={'text'}
            name={'email'}
            placeholder='Enter your email address'
            value={email}
            onChange={setEmail}
          />
          <Label>Address</Label>
          <InputBackOffice
            id={'address'}
            type={'text'}
            placeholder={'Enter your address'}
            name={'address'}
            value={address || ''}
            onChange={setAddress}
          />

          <Label>Postal code</Label>
          <InputBackOffice
            id={'postal'}
            type={'text'}
            placeholder={'Enter postal code'}
            name={'postal'}
            value={postal || ''}
            onChange={setPostal}
          />

          <Label>City</Label>
          <InputBackOffice
            id={'city'}
            type={'text'}
            placeholder={'Enter your city'}
            name={'city'}
            value={city || ''}
            onChange={setCity}
          />

          <Label>Country</Label>
          <Select
            onClick={() => {
              setIsVisible(true);
            }}
            style={{ cursor: 'pointer' }}>
            <FlexCenter>
              {countryImage && (
                <img
                  src={countryImage}
                  alt='flag'
                  style={{
                    marginRight: '20px',
                    width: '28px',
                    height: '20px'
                  }}
                />
              )}

              <div>{country || 'Select country'}</div>
            </FlexCenter>
            <ArrowPolygon direction={''} />
          </Select>

          <Button
            mt={10}
            disabled={
              name === '' ||
              lastName === '' ||
              email === '' ||
              address === '' ||
              postal === '' ||
              city === '' ||
              country === ''
            }
            onClick={() => handleOpenModal()}>
            Pay
          </Button>

          <BottomDrawer isVisible={isVisible} onClose={onClose} height={'90vh'}>
            <SInputContainer>
              <img src={search} alt='search.svg' />
              <SInput
                placeholder={'Select country'}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </SInputContainer>
            {countryList &&
              countryList
                ?.sort((a) => (a.name === userCountry ? -1 : 1))
                .filter((value) => {
                  if (searchTerm === '') {
                    return value;
                  } else if (
                    value.name.toLowerCase().includes(searchTerm.toLowerCase())
                  ) {
                    return value;
                  } else return null;
                })
                .map((country, i) => {
                  if (country.hidden) return null;
                  return (
                    <div
                      onClick={() => {
                        setCountry(country.name);
                        setCountryCode(country.code);
                        setCountryImage(country.flag);
                        setIsVisible(false);
                        checkCountry(country);
                      }}
                      key={i}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        cursor: 'pointer'
                      }}>
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          marginBottom: '20px'
                        }}>
                        <img
                          src={country.flag}
                          alt='flag'
                          style={{
                            marginRight: '20px',
                            width: '28px',
                            height: '20px'
                          }}
                        />

                        <P2>{country.name}</P2>
                      </div>
                      {country.checked && (
                        <img
                          src={check}
                          alt='check'
                          style={{ marginBottom: '30px' }}
                        />
                      )}
                    </div>
                  );
                })}
          </BottomDrawer>
        </div>
      )}
    </>
  );
};

export default PaymentPage;
